export { default as CrudeCard } from './component';
